import React, { useEffect, useState } from "react";
import "./DateDifference.css";
import { Link } from 'react-router-dom';

function DateDifference() {
  const [targetDate, setTargetDate] = useState(null);
  const [viewMode, setViewMode] = useState("full"); // full | days | hours | minutes
  const [output, setOutput] = useState("");

  useEffect(() => {
    if (!targetDate) {
      setOutput("Please select a date.");
      return;
    }

    const updateOutput = () => {
      const now = new Date();
      let isFuture = targetDate > now;

      let start = isFuture ? now : targetDate;
      let end = isFuture ? targetDate : now;

      // Calendar-aware difference
      let years = end.getFullYear() - start.getFullYear();
      let months = end.getMonth() - start.getMonth();
      let days = end.getDate() - start.getDate();

      if (days < 0) {
        months -= 1;
        const prevMonth = new Date(end.getFullYear(), end.getMonth(), 0);
        days += prevMonth.getDate();
      }

      if (months < 0) {
        months += 12;
        years -= 1;
      }

      // Millisecond difference
      const diffMs = Math.abs(end - start);
      const totalDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      const totalHours = Math.floor(diffMs / (1000 * 60 * 60));
      const totalMinutes = Math.floor(diffMs / (1000 * 60));
      const totalSeconds = Math.floor(diffMs / 1000);

      // Leftover time after removing full days
      const leftoverMs = diffMs % (1000 * 60 * 60 * 24);
      const hours = Math.floor(leftoverMs / (1000 * 60 * 60));
      const minutes = Math.floor((leftoverMs / (1000 * 60)) % 60);
      const seconds = Math.floor((leftoverMs / 1000) % 60);

      if (viewMode === "days") {
        setOutput(`${totalDays} days ${isFuture ? "remaining" : "ago"}`);
      } else if (viewMode === "hours") {
        setOutput(`${totalHours} hours ${isFuture ? "remaining" : "ago"}`);
      } else if (viewMode === "minutes") {
        setOutput(`${totalMinutes} minutes ${isFuture ? "remaining" : "ago"}`);
      } else if (viewMode === "seconds") {
        setOutput(`${totalSeconds} seconds ${isFuture ? "remaining" : "ago"}`);
      } else {
        setOutput(
          `${years} years ${months} months ${days} days ${hours}h:${minutes}m:${seconds}s ${isFuture ? "remaining" : "ago"}`
        );
      }
    };

    updateOutput();
    const timer = setInterval(updateOutput, 1000);

    return () => clearInterval(timer);
  }, [targetDate, viewMode]);

  return (
    <div className="app">
      <h1><u>Date Difference Details</u></h1>

      <label htmlFor="datePicker">Choose a date: </label>
      <input
        type="date"
        id="datePicker"
        onChange={(e) => setTargetDate(new Date(e.target.value))}
      />

      <div className="options">
        <button className="btn full" onClick={() => setViewMode("full")}>Full</button>
        <button className="btn days" onClick={() => setViewMode("days")}>Days</button>
        <button className="btn hours" onClick={() => setViewMode("hours")}>Hours</button>
        <button className="btn minutes" onClick={() => setViewMode("minutes")}>Minutes</button>
        <button className="btn seconds" onClick={() => setViewMode("seconds")}>Seconds</button>
      </div>

      <div className="countdown-box">
        <h2>{output}</h2>
      </div>
<div>   <br/></div>
      <div>
        <section className="about-section">
        <p>
          Date Difference details in Full details years, months, days, hours, minutes and seconds.
        </p>
      </section>
      </div>
      <div>
        
         <footer className="home-footer">
        <div className="footer-banner1">
          Thank you for choosing JAL Market to simplify your invoicing smooth and hassle-free! 🛒
        </div>
        <div>
          <img className="image-ban" src="./Images/jalm.png" alt="Just A Little Market" width="50" height="50" />
          
        </div>
        <p>© 2025 JALM  • Easy Invoice. &nbsp; &nbsp;   <Link to="/PrivacyPolicy" >Privacy Policy</Link>
          </p>
          
      </footer>
      </div>
      
    </div>
  );
}

export default DateDifference;

